export enum StepEnum {
  None,
  Init,
  ApplicationName,
  Connectors,
  Consumer,
}
